export const etkinlikler = [
  {
    "id": "sinav-kaygisi-ve-nefes-egzersizleri",
    "title": "SINAV KAYGISI VE NEFES EGZERSİZLERİ",
    "image": "/files/images/l1610201816113799.jpg",
    "description": "SINAV KAYGISI VE NEFES EGZERSİZLERİÖğrencilerin, sınava yüklediği anlamlar, sınavla ilgili zihinde oluşturulan imaj, sınav sonrası duruma ilişkin atıflar ve sınav sonrası elde edilecek kazanımlara verilen önem sınav kaygısı oluşumu üzerinde etkili olmaktadır. Sınava hazırlanan 8.ve 12. Sınıf öğrencilerimizin bu kaygılarını yok edebilmenin yollarını yaşam koçu aslı metin’den dinledik. Aslı Metin in yapmış olduğu sunum da öğrencilerimiz nefes alma ve gevşeme egzersizlerini, düşünceyi durdurma ve dikkati başka noktalara odaklama teknikleri hakkında bilgi sahibi oldular. Özel Güney Gelişim Okulları olarak Yaşam Koçu Aslı Metin’e teşekkür ederiz.",
    "gallery": [
      "/files/images/l1610201816113799.jpg",
      "/files/images/l1610201816113893.jpg",
      "/files/images/l16102018161233.jpg",
      "/files/images/l1610201816123190.jpg"
    ],
    "video": ""
  },
  {
    "id": "girisimcilik-kulubu-ve-interact-kulubu",
    "title": "Girişimcilik Kulübü ve Interact Kulübü",
    "image": "/files/images/l76201810370345.jpg",
    "description": "Girişimcilik Kulübü ve Interact KulübüÖzel Güney Gelişim Anadolu Lisesi Girişimcilik Kulübü ve Interact Kulübü olarak Çavak Günferi Karagenç İlköğretim Okulu'na bir kütüphane yapıldı. Başlatılan kampanya ile ortaokuldan ve liseden hikaye kitapları toplandı. Gönüllü bir marangoz bulunarak dolap yaptırıldı. Kütüphanenin duvarları lise öğrencileri tarafından boyandı. Aynı zamanda okul için çeşitli spor malzemeleri temin edilerek  okula ziyarete gidildi. Okula giden lise öğrencilerimizle ilköğretim çocukları saatlerce çeşitli etkinlikler yaparak birlikte güzel vakit geçirdiler.",
    "gallery": [
      "/files/images/l76201810370345.jpg",
      "/files/images/l76201810370454.jpg",
      "/files/images/l76201810370563.jpg",
      "/files/images/l76201810370688.jpg",
      "/files/images/l76201810370829.jpg",
      "/files/images/l76201810370938.jpg",
      "/files/images/l7620181038063.jpg"
    ],
    "video": ""
  },
  {
    "id": "onkoloji-servisi",
    "title": "ONKOLOJİ SERVİSİ",
    "image": "/files/images/l76201893859142.jpg",
    "description": "ONKOLOJİ SERVİSİGüney Gelişim Anadolu Lisesi Girişimcilik Kulübü Mersin Şehir Hastanesi Onkoloji Servisinde bir sosyal sorumluluk projesi gerçekleştirdi. Proje kapsamında  Girişimcilik Kulübü orada bulunan çocuklara çeşitli hediyeler alarak , onlarla oyun saati organize ettiler.",
    "gallery": [
      "/files/images/l76201893859142.jpg",
      "/files/images/l76201893859236.jpg",
      "/files/images/l76201893859704.jpg",
      "/files/images/l76201893959157.jpg"
    ],
    "video": ""
  },
  {
    "id": "lise-tanitim-semineri",
    "title": "LİSE TANITIM SEMİNERİ",
    "image": "/files/images/l76201893457939.jpg",
    "description": "LİSE TANITIM SEMİNERİ22 Mayıs 2018 tarihinde Güney Gelişim Anadolu Lisesi ; ortaokul velilerimize bir tanıtım semineri düzenledi. Seminerde öğrencilerin lisemizi neden tercih etmesi gerektiği , lisemizin eğitim sistemi ve sosyal faaliyetleri anlatıldı. Seminerimize öğrencilerimizden Azra DEMİR, Bora BALLI ve Selin VETEM; velilerimizden ise Koray BALLI ve Ebru KONUK konuşmacı olarak katılarak tecrübelerini aktardı.",
    "gallery": [
      "/files/images/l76201893457939.jpg",
      "/files/images/l76201893557111.jpg",
      "/files/images/l76201893557252.jpg",
      "/files/images/l76201893557408.jpg",
      "/files/images/l76201893557549.jpg"
    ],
    "video": ""
  },
  {
    "id": "okubuluspaylas",
    "title": "OKU-BULUŞ-PAYLAŞ",
    "image": "/files/images/l3152018213551557.JPG",
    "description": "OKU-BULUŞ-PAYLAŞÖzel Güney Gelişim Anadolu Lisesi Oku-Buluş-Paylaş Kulübü olarak bu kez Mahmut Arslan Anadolu Lisesine giderek F. Kafka’nın “Dönüşüm” adlı eserini tartıştık. Dönüşüm; hiyerarşi ve otorite düşüncesiyle temellenen, bu amaçla sözü edilen düşünceyi önce aile kurumu içerisinde odaklaştıran toplum içindeki tragedyasıdır. Kafka bu tragedyayı Gregor Samsa ekseninde ele alırken toplumun bireyi mahkum ettiği köleliklere ağır ve çarpıcı bakış açıları sunar. Öğrencilerimiz kitabı okuduktan sonra Mehmet Akif Ersoy Sosyal Bilimler Anadolu Lisesi, Yahya Akel Fen Lisesi ve Mahmut Arslan Anadolu Lisesi ile buluşarak bu bakış açılarını oldukça can alıcı yönleriyle irdeledik ve uzun uzun tartışıp sorguladık Öğrencilerimizi bu entelektüel çalışmalarından ötürü tebrik ediyoruz.",
    "gallery": [
      "/files/images/l532018133141585.JPG",
      "/files/images/l532018133141913.JPG",
      "/files/images/l53201813942991.JPG"
    ],
    "video": ""
  },
  {
    "id": "siir-dinletisi",
    "title": "ŞİİR DİNLETİSİ",
    "image": "/files/images/l2952018201812300.JPG",
    "description": "ŞİİR DİNLETİSİGüney Gelişim Anadolu Lisesi öğrenci ve öğretmenlerinin farkındalık oluşturmak amacıyla hazırladıkları ‘’çocuk’’ temalı ‘’Bir Şair, Bir Çocuk, Herhangi Bir Gün’’ adlı şiir dinletisi oldukça duygulu anların yaşanmasına neden oldu.Dinletimizde işçi çocuklardan çocuk gelinlere kadar pek çok çocuğun sorunu dile getirilerek ünlü şairlerin şiirleri okundu. Öğrencilerimize bu anlamlı şiir dinletisine katkıda bulundukları için teşekkür ediyoruz.",
    "gallery": [
      "/files/images/l2952018201812300.JPG",
      "/files/images/l2952018201912300.JPG",
      "/files/images/l2952018202012284.JPG",
      "/files/images/l2952018202112253.JPG",
      "/files/images/l2952018202212331.JPG",
      "/files/images/l2952018202312472.JPG",
      "/files/images/l2952018202412425.JPG",
      "/files/images/l2952018202512347.JPG"
    ],
    "video": "http://dizihitplayer.xyz/player/flex/9f09a9f5009a43769faa4a60ad6aba74"
  },
  {
    "id": "19-mayis-ataturk-u-anma-genclik-ve-spor-bayrami",
    "title": "19 Mayıs Atatürk'ü Anma Gençlik ve Spor Bayramı",
    "image": "/files/images/l295201819125624.JPG",
    "description": "19 Mayıs Atatürk'ü Anma Gençlik ve Spor Bayramı‘’Bütün ümidim gençliktedir.’’ diyen  Ata’mızın beklentisine yakışan bir vizyonla yetişen Gelişim Koleji gençleri, 19 Mayıs Atatürk’ü Anma Gençlik ve Spor Bayramı’nı gerçek bir bayram coşkusuyla geçirdi.Programımız, 18 Mayıs Cuma günü 13.00’te ‘’Atatürk’ü Anma’’ töreni kapsamında lise öğrencilerimizin hazırlayıp konferans salonunda sunduğu ‘’Çılgın Türkler’’ adlı oratoryoyla başladı.Oratoryo sonrası bayramımız konferans salonunda verilen gençlik konseriyle devam etti.Konser bitimiyle öğrenci ve öğretmenlerimiz bahçede futbol, voleybol, basketbol, okçuluk, geleneksel yakan top, langırt gibi sportif aktiviteler gerçekleştirdi.Akşam yemeği açık havada barbekü eşliğinde bir şenlik havasında yenildi ve yemek sonrası yakılan gençlik ateşi etrafında 22.00’ye kadar keyifli zaman geçirildi.",
    "gallery": [
      "/files/images/l295201819125624.JPG",
      "/files/images/l295201819135624.JPG",
      "/files/images/l295201819145671.JPG",
      "/files/images/l2952018191556133.JPG",
      "/files/images/l2952018191656227.JPG",
      "/files/images/l2952018191756227.JPG",
      "/files/images/l2952018191856258.JPG"
    ],
    "video": ""
  },
  {
    "id": "kahoot-competition",
    "title": "KAHOOT COMPETITION",
    "image": "/files/images/l1552018204817371.JPG",
    "description": "KAHOOT COMPETITIONThree teams took part in the kahoot competition this year.   The students demonstrated their great teamwork skills while entertaining us at the same time. Each team showed great ambition and knowledge and each team worked hard to win.  At the end of such a challenging competition, the winners are Alp Özer,  Begüm Gök,  Ali Taha Öğündür, Can Berk Çavuşoğlu. Congratulations to all who took the stage!",
    "gallery": [
      "/files/images/l1552018204817371.JPG",
      "/files/images/l1552018204917324.JPG",
      "/files/images/l1552018205017278.JPG",
      "/files/images/l1552018205117262.JPG"
    ],
    "video": ""
  },
  {
    "id": "meslek-tanitim-semineri",
    "title": "Meslek Tanıtım Semineri",
    "image": "/files/images/l752018103838623.JPG",
    "description": "Meslek Tanıtım Semineri26 Nisan Salı günü okulumuzda Mersin Rotaract Kulübü tarafından meslek tanıtım semineri gerçekleştirildi. Seminer kapsamında avukat, doktor, aşçı, ceo, endüstri mühendisi ve bir psikolog üniversiteyi kazanma süreçlerini, mesleğe başlama serüvenlerini ve mesleklerinde kendilerini geliştirme adına yaptıkları aşamaları anlatarak öğrencilerimize tecrübelerini aktardılar. Seminer sonucunda öğrencilerimizin sorularını cevaplayarak onlara meslek ve üniversite seçiminde dikkat etmeleri gereken konularda bilgi verdiler.",
    "gallery": [
      "/files/images/l752018103838623.JPG"
    ],
    "video": ""
  },
  {
    "id": "12-siniflarimizin-yoga-etkinligi",
    "title": "12. Sınıflarımızın Yoga Etkinliği",
    "image": "/files/images/l2332018103511772.jpg",
    "description": "12. Sınıflarımızın Yoga EtkinliğiSınav hazırlıkları yoğun bir tempoda devam eden 12. sınıflarımız bugün doğayla iç içe bir gün geçirdiler. Zihinlerini dinlendiren, streslerini azaltan konstantrasyonlarını güçlendiren yoga çalışmasıyla başlayan etkinliğimiz lezzetli bir mangal ziyafetiyle son buldu.",
    "gallery": [
      "/files/images/l2332018103511772.jpg",
      "/files/images/l2332018103511850.jpg",
      "/files/images/l2332018103511897.jpg",
      "/files/images/l2332018103511975.jpg",
      "/files/images/l233201810361122.jpg",
      "/files/images/l233201810361184.jpg",
      "/files/images/l2332018103611131.jpg",
      "/files/images/l2332018103611194.jpg"
    ],
    "video": "https://www.youtube.com/embed/2BlxPs0XSvM?ecver=1"
  },
  {
    "id": "okubuluspaylas",
    "title": "OKU-BULUŞ-PAYLAŞ",
    "image": "/files/images/l1932018171112486.JPG",
    "description": "OKU-BULUŞ-PAYLAŞÖzel Güney Gelişim Anadolu Lisesi Oku-Buluş-Paylaş Kulübü olarak bu kez Mahmut Arslan Anadolu Lisesine giderek F. Kafka’nın “Dönüşüm” adlı eserini tartıştık. Dönüşüm; hiyerarşi ve otorite düşüncesiyle temellenen, bu amaçla sözü edilen düşünceyi önce aile kurumu içerisinde odaklaştıran toplum içindeki tragedyasıdır. Kafka bu tragedyayı Gregor Samsa ekseninde ele alırken toplumun bireyi mahkum ettiği köleliklere ağır ve çarpıcı bakış açıları sunar. Öğrencilerimiz kitabı okuduktan sonra Mehmet Akif Ersoy Sosyal Bilimler Anadolu Lisesi, Yahya Akel Fen Lisesi ve Mahmut Arslan Anadolu Lisesi ile buluşarak bu bakış açılarını oldukça can alıcı yönleriyle irdeledik ve uzun uzun tartışıp sorguladık Öğrencilerimizi bu entelektüel çalışmalarından ötürü tebrik ediyoruz.",
    "gallery": [
      "/files/images/l532018133141585.JPG",
      "/files/images/l532018133141913.JPG",
      "/files/images/l53201813942991.JPG"
    ],
    "video": ""
  },
  {
    "id": "hayallerim-gercek-olsa",
    "title": "Hayallerim Gerçek Olsa",
    "image": "/files/images/l93201892637823.jpg",
    "description": "Hayallerim Gerçek OlsaÖzel Güney Gelişim Anadolu Lisesi; Sosyal Bilimler Anadolu LisesiDumlupınar İ.H.L, Yahya Akel Fen Lisesi, Yahya Günsür Teknik Ve Endüstri Meslek Lisesi ile “Hayallerim Gerçek Olsa” projesine hayat veriyor.Bu çalışmadaki amaç, ekonomik ve eğitim düzeyinin birbirinden farklı olduğu ilimiz ilkokullarındaki öğrencilere, hayal ettikleri dünyayı oluşturan unsurların ayrımına vardırmak, hayallerin çocuklar için mutluluğa giden yolda önemli bir etken olduğunu göstermek ve hayaller aracılığıyla hedef oluşturarak evrensel düzeyde başarılı bir birey olmasına farkındalık yaratmaktır. Değişen dünyada görsel medyanın çocuğun hayal dünyasını olumsuz yönde nasıl etkilediği, bunun yetişkin dünyasına nasıl sirayet ettiğini değerlendirmektir. Bu çizgiden yola çıkarak Gökçebelen İlköğretim Okulu, Aydınlıkevler İlkokulu, Doğa Koleji, Dr. Kamil Tarhan İlkokulu öğrencilerinin hayallerini çizdiği resimleri öğrencilerimiz öyküleştiriyor. Diğer bölge okullarının da katılımıyla minik ellerin çizdiği hayaller kitaplaşarak dile geliyor.",
    "gallery": [
      "/files/images/l93201892637823.jpg",
      "/files/images/l93201892637870.jpg",
      "/files/images/l93201892637901.jpg",
      "/files/images/l93201892637964.jpg",
      "/files/images/l9320189273711.jpg"
    ],
    "video": ""
  },
  {
    "id": "okubuluspaylas",
    "title": "OKU-BULUŞ-PAYLAŞ",
    "image": "/files/images/l532018133141585.JPG",
    "description": "OKU-BULUŞ-PAYLAŞÖzel Güney Gelişim Anadolu Lisesi Oku-Buluş-Paylaş Kulübü olarak bu kez Mahmut Arslan Anadolu Lisesine giderek F. Kafka’nın “Dönüşüm” adlı eserini tartıştık. Dönüşüm; hiyerarşi ve otorite düşüncesiyle temellenen, bu amaçla sözü edilen düşünceyi önce aile kurumu içerisinde odaklaştıran toplum içindeki tragedyasıdır. Kafka bu tragedyayı Gregor Samsa ekseninde ele alırken toplumun bireyi mahkum ettiği köleliklere ağır ve çarpıcı bakış açıları sunar. Öğrencilerimiz kitabı okuduktan sonra Mehmet Akif Ersoy Sosyal Bilimler Anadolu Lisesi, Yahya Akel Fen Lisesi ve Mahmut Arslan Anadolu Lisesi ile buluşarak bu bakış açılarını oldukça can alıcı yönleriyle irdeledik ve uzun uzun tartışıp sorguladık Öğrencilerimizi bu entelektüel çalışmalarından ötürü tebrik ediyoruz.",
    "gallery": [
      "/files/images/l532018133141585.JPG",
      "/files/images/l532018133141913.JPG",
      "/files/images/l53201813942991.JPG"
    ],
    "video": ""
  },
  {
    "id": "rotary-kulubu-sinav-kaygisi-semineri",
    "title": "Rotary Kulübü “Sınav Kaygısı” Semineri",
    "image": "/files/images/l28220181619336.JPG",
    "description": "Rotary Kulübü “Sınav Kaygısı” SemineriRotary Kulübünün başlattığı proje kapsamında, uzman psikolojik danışman İzzet Zülküf Çelik sınav gruplarımıza “Sınav Kaygısı” temalı seminer verdi. 15 Şubat 2018 tarihinde düzenlenen etkinliğimize ortaokul gruplarımızdan 7. Ve 8. Sınıflar, lise gruplarımızdan 11. Ve 12. Sınıflar katıldı. İnteraktif bir şekilde gerçekleşen etkinliğinizde öğrencilerimize sınav kaygısı, aşamaları ve baş etme yöntemleri anlatılarak bu konuda bilinçlenmeleri sağlandı. Her insanın hayatın her aşamasında, farklı nedenlerle yaşayabildiği kaygı olgusu karşısında, öğrencilerimizin bilişsel ve duygusal olarak güçlenmesi bu etkinlikteki temel amacımızdı.",
    "gallery": [
      "/files/images/l28220181619336.JPG",
      "/files/images/l28220181629321.JPG",
      "/files/images/l28220181639290.crdownload"
    ],
    "video": ""
  },
  {
    "id": "bir-dilegim-var-tanitim-semineri",
    "title": "Bir Dileğim Var Tanıtım Semineri",
    "image": "/files/images/l282201816573887.png",
    "description": "Bir Dileğim Var Tanıtım Semineri28 Şubat  2018 tarihinde Bir Dileğim Var derneğinin kurucusu oyuncu Alper Türedi Lise Rehberlik Servisi tarafından derneği tanıtmak ve geri dönüşüme farkındalık bilinci uyandırmak amacıyla okulumuza davet edildi. Alper Türedi 2014 yılında kurulan, lösemili çocuklar için faaliyet gösteren bu derneğin amaçlarından, günümüze kadar başardıklarından, gerçekleştirdikleri dileklerden lise ve ortaokul bölümü öğrencilerimize bahsederek onlarda sosyal sorumluluk bilinci uyandırdı. Öğrenciler tarafından oldukça beğenilen bu etkinlik onların duyarlılığını arttırarak, bu projeye destek olmalarını sağladı.",
    "gallery": [
      "/files/images/l282201816573887.png",
      "/files/images/l28220181658328.png"
    ],
    "video": ""
  },
  {
    "id": "birinci-geleneksel-kardes-okul-projesi",
    "title": "BİRİNCİ GELENEKSEL  KARDEŞ OKUL PROJESİ",
    "image": "/files/images/l171201892312647.jpg",
    "description": "BİRİNCİ GELENEKSEL  KARDEŞ OKUL PROJESİÖzel Güney Gelişim Anadolu Lisesi öğrencileriMersin’de belirledikleri bir köy okulu için sosyal sorumluluk projesi başlattılar. Projenin amacı; yeni yıldan önce belirlenen ilkokuldaki miniklerle beraber vakit geçirmek, onlara oyuncak hediye etmek ve çeşitli ihtiyaçlarını karşılamaktı. Kışlık kıyafet, kırtasiye malzemeleri, oyuncak listeleri oluşturularak çalışmalara başlandı. Özel Güney Gelişim Ortaokulu tarafından kırtasiye malzemelerinin tamamı temin edildi. Lise bölümümüz tarafından ise kışlık kıyafet, ayakkabıveoyuncaklar temin edildi. Toplanılan bağışlarla 29 Aralık 2017 tarihinde Arslanköy İlköğretim Okulu’nu siyaret ederek projemizi gerçekleştirdik.Miniklerimize hediyelerini verdikten sonra onlarla çeşitli oyunlar ve aktiviteler yaparak yeni yıla girmeden önce beraber güzelbir gün geçirdik. Miniklerimizle beraber eğlendiğimiz bu projede Gelişim Lisesi öğrencileri ve ortaokulu olarak sosyal farkındalık bilincini uyandırdık.",
    "gallery": [
      "/files/images/l171201892312647.jpg",
      "/files/images/l171201892312772.jpg",
      "/files/images/l171201892312866.jpg",
      "/files/images/l171201892312975.jpg",
      "/files/images/l171201892412116.jpg",
      "/files/images/l171201892412210.jpg"
    ],
    "video": ""
  },
  {
    "id": "arkadaslik-haftasi",
    "title": "ARKADAŞLIK HAFTASI",
    "image": "/files/images/l41201814541316.jpg",
    "description": "ARKADAŞLIK HAFTASIÖzel Güney Gelişim Anadolu Lisesi olarak Arkadaşlık Haftasında (11-15) okullarda şiddet ve akran zorbalığına dikkat çekmek istedik. Özellikle yaş düzeyleri ve gelişim özellikleri göz önüne alınarak 9. Sınıflarımız için Akran Zorbalığı temalı sunum yapıldı. Bu haftanın önemini kavramak adına öğrencilerimizle birlikte kitap ayracı, anahtarlık ve bileklik yaptık. Öğrencilerimizin yaptığı ayraçlar lisemizde başlatmış olduğumuz köy okulu yardım kampanyası için gideceğimiz okuldaki minik arkadaşlarımıza hediye edilecek.",
    "gallery": [
      "/files/images/l41201814541316.jpg",
      "/files/images/l41201814541394.jpg",
      "/files/images/l412018145413141.jpg",
      "/files/images/l412018145413204.jpg",
      "/files/images/l412018145413297.jpg"
    ],
    "video": ""
  },
  {
    "id": "hazirliksiz-konusma",
    "title": "HAZIRLIKSIZ KONUŞMA",
    "image": "/files/images/l12122017111237345.jpg",
    "description": "HAZIRLIKSIZ KONUŞMAİletişim becerilerini geliştirmek, duygu ve düşüncelerini etkili ifade etmek, hitap yeteneğini güçlendirmek amacıyla düzenlediğimiz “Hazırlıksız Konuşma Yarışması” öğrenciler tarafından büyük beğeni topladı. Başarılı konuşmalarıyla dinleyenleri etkileyen öğrencilerimizle gurur duyuyoruz.",
    "gallery": [
      "/files/images/l143201713748423.JPG",
      "/files/images/l1432017131048486.JPG",
      "/files/images/l1432017131348126.JPG",
      "/files/images/l1432017131548251.JPG",
      "/files/images/l1432017131848360.JPG",
      "/files/images/l143201713204879.JPG"
    ],
    "video": ""
  },
  {
    "id": "okubuluspaylas-kulubu",
    "title": "OKU-BULUŞ-PAYLAŞ KULÜBÜ",
    "image": "/files/images/l12122017115033548.jpg",
    "description": "OKU-BULUŞ-PAYLAŞ KULÜBÜÖzel Güney Gelişim Anadolu Lisesi Oku-Buluş-Paylaş Kulübü olarak; Mehmet Akif Sosyal Bilimler Anadolu Lisesi, Mahmut Arslan Anadolu Lisesi ve Yahya Akel Fen Lisesi ile buluşarak Goethe'nin \"Genç Werther'in Acılarını\" tartıştık.Öğrencilerimiz kitap kahramanlarıyla özdeşim kurarak \"neyi-neden\" yaptıklarını, kaharamanların yaşadığı dönemin siyasi ve sosyal sorunlarını anlamaya ve anlatmaya çalıştı. \"Genç Werther'in Acıları\" ile tanışan öğrencilerimiz oldukça entelektüel bir sohbet gerçekleştirdi.",
    "gallery": [
      "/files/images/l12122017115033548.jpg",
      "/files/images/l12122017115033689.jpg",
      "/files/images/l12122017115033814.jpg"
    ],
    "video": ""
  },
  {
    "id": "kaynasma-kahvaltisi",
    "title": "Kaynaşma Kahvaltısı",
    "image": "/files/images/l1711201794253179.JPG",
    "description": "Kaynaşma Kahvaltısı9 Kasım Perşembe günü Lise öğrencilerimiz Doruklu Restaurant’ta Sene Başı Kaynaşma kahvaltısında bir araya geldiler.",
    "gallery": [
      "/files/images/l1711201794253179.JPG",
      "/files/images/l1711201794253304.JPG",
      "/files/images/l1711201794253429.JPG",
      "/files/images/l1711201794253569.JPG",
      "/files/images/l1711201794253679.JPG"
    ],
    "video": ""
  },
  {
    "id": "ogrenci-meclis-baskanligi-secimi",
    "title": "ÖĞRENCİ MECLİS BAŞKANLIĞI SEÇİMİ",
    "image": "/files/images/l30102017165816267.jpg",
    "description": "ÖĞRENCİ MECLİS BAŞKANLIĞI SEÇİMİ2017-2018 yılı Özel Güney Gelişim Anadolu Lisesi Öğrenci Meclis Başkanlığına okulumuz öğrencilerindenAli Taha ÖĞÜNDÜR,Ahmet Ediz DOYDUveRavel Deniz SAYGIadaylıklarını koymuşlardır.Bir hafta boyunca süren seçim kampanyaları neticesinde 30/10/2017 Pazartesi günü yapmış olduğumuz oylamadaÖğrenci Meclis BaşkanlığınaAhmet Ediz DOYDUseçilmiştir.",
    "gallery": [
      "/files/images/l30102017165816267.jpg",
      "/files/images/l30102017165816798.jpg",
      "/files/images/l30102017165916314.jpg",
      "/files/images/l30102017165916814.jpg",
      "/files/images/l3010201716017298.jpg",
      "/files/images/l3010201716017783.jpg",
      "/files/images/l3010201716117298.jpg",
      "/files/images/l3010201716117783.jpg"
    ],
    "video": ""
  },
  {
    "id": "lisemizin-sosyal-sorumluluk-projesi",
    "title": "LİSEMİZİN SOSYAL SORUMLULUK PROJESİ",
    "image": "/files/images/l19102017102656216.jpg",
    "description": "LİSEMİZİN SOSYAL SORUMLULUK PROJESİGüney Gelişim Anadolu Lisesi \"Interact Kulübü\" üyeleri daha önce de birçok kez gerçekleştirdikleri projelerine ek olarak18/10/2017 tarihindeRotary'nin de desteği ileMersin Alzheimer DerneğineBotanik Kış Bahçesi inşa ederek özgürce dizayn ettiler.",
    "gallery": [
      "/files/images/l19102017102656216.jpg",
      "/files/images/l19102017102656341.jpg",
      "/files/images/l19102017102656466.jpg",
      "/files/images/l19102017102656559.jpg",
      "/files/images/l19102017102656653.jpg",
      "/files/images/l19102017103058371.jpg"
    ],
    "video": ""
  },
  {
    "id": "9-siniflarimizin-dogu-karadeniz-gezisi",
    "title": "9. Sınıflarımızın Doğu Karadeniz Gezisi",
    "image": "/files/images/l910201713353246.jpg",
    "description": "9. Sınıflarımızın Doğu Karadeniz Gezisi2-7 Ekim 2017 tarihlerindeÖzel Güney Gelişim Anadolu Lisesiolarak9. Sınıflarımızıkapsayan, bu yıl ilk kez düzenlediğimizDoğu Karadenizgezimizi gerçekleştirdik. Kültürel ve tarihi esintiler barındıran, amaçlandığı gibi öğrenciler arasında dostluk, kaynaşmapaylaşma ve arkadaş edinme sürecini hızlandıran keyifli bir etkinlik oldu.",
    "gallery": [
      "/files/images/l910201713353246.jpg",
      "/files/images/l91020171335215.jpg",
      "/files/images/l91020171335308.jpg",
      "/files/images/l91020171335402.jpg",
      "/files/images/l91020171335480.jpg",
      "/files/images/l91020171335590.jpg",
      "/files/images/l91020171345261.jpg",
      "/files/images/l91020171345902.jpg",
      "/files/images/l91020171355605.jpg",
      "/files/images/l91020171365293.jpg",
      "/files/images/l91020171365386.jpg",
      "/files/images/l91020171365496.jpg",
      "/files/images/l91020171365574.jpg",
      "/files/images/l91020171365699.jpg",
      "/files/images/l91020171365793.jpg",
      "/files/images/l91020171365902.jpg",
      "/files/images/l91020171365996.jpg",
      "/files/images/l9102017137590.jpg",
      "/files/images/l91020171375183.jpg",
      "/files/images/l91020171375308.jpg",
      "/files/images/l91020171375355.jpg",
      "/files/images/l91020171375496.jpg",
      "/files/images/l91020171375621.jpg",
      "/files/images/l91020171375715.jpg",
      "/files/images/l91020171375840.jpg",
      "/files/images/l91020171375965.jpg"
    ],
    "video": ""
  },
  {
    "id": "liseli-olmak",
    "title": "LİSELİ OLMAK",
    "image": "/files/images/l2102017174557679.jpeg",
    "description": "LİSELİ OLMAKÖzel Güney Gelişim Anadolu Lisesiolarak 2017-2018 Eğitim-Öğretim yılına büyük bir heyecanla \"merhaba\" dedik.9. sınıf velilerimiz için düzenlenen ilk veli toplantımız Rehber ÖğretmenimizÇağla KARAKILIÇ'ın \"Liseli Olmak\" konulu sunumuyla başladı.Sunum sonrası okul bahçesinde velilerimizle ikramlar eşliğinde sıcak bir \"Veli-Öğretmen Tanışma\" toplantısı gerçekleştirildi.Giderek büyüyen bir aile olmanın gururuyla bünyemize yeni katılan öğrencilerimize \"Hoş geldiniz\" diyor, başarılı bir yıl diliyoruz.",
    "gallery": [
      "/files/images/l2102017174557679.jpeg",
      "/files/images/l2102017174557804.jpeg",
      "/files/images/l2102017174557913.jpeg",
      "/files/images/l210201717465738.jpeg",
      "/files/images/l2102017174657304.jpeg"
    ],
    "video": ""
  },
  {
    "id": "19-mayis-senligi",
    "title": "19 MAYIS ŞENLİĞİ",
    "image": "/files/images/l2652017111547507.JPG",
    "description": "19 MAYIS ŞENLİĞİ19 MAYIS ŞENLİĞİÖzel Güney Gelişim Anadolu Lisesi öğrencileri 19 Mayıs Atatürk’ü Anma Gençlik ve Spor Bayramı’nda Ata’sını büyük bir gururla andı. 19 Mayıs Atatürk’ü Anma Gençlik ve Spor Bayramı kapsamında düzenlenen 19 Mayıs Şenliği’miz konferans salonunda Mustafa Kemal Atatürk’ü anma programı için hazırlanan “Atatürk Oratoryosu”yla başladı. Ardından öğretmenlerimizin öncülüğünde bahçemizde Survıvor, okçuluk,  basketbol, voleybol, futbol, yakan top gibi çeşitli etkinlikler gerçekleştirildi. Sportif faaliyetlerin sonrasında açık havada yapılan barbekü partisi ve yine açık havada dondurma ve patlamış mısır eşliğinde yapılan sinema keyfi ile günümüzü büyük bir keyifle sonlandırdık.",
    "gallery": [
      "/files/images/l2652017111547507.JPG",
      "/files/images/l2652017111847304.JPG",
      "/files/images/l2652017112047757.JPG",
      "/files/images/l2652017112347351.JPG",
      "/files/images/l2652017112547899.JPG",
      "/files/images/l2652017111653432.JPG",
      "/files/images/l265201711195373.JPG",
      "/files/images/l2652017112153120.JPG",
      "/files/images/l2652017112353526.JPG",
      "/files/images/l2652017112553729.JPG",
      "/files/images/l2652017112753745.JPG",
      "/files/images/l2652017113053311.JPG"
    ],
    "video": "https://www.youtube.com/embed/XMR8dgJ6I74?ecver=1"
  },
  {
    "id": "meslek-tanitimi",
    "title": "Meslek Tanıtımı",
    "image": "/files/images/l2552017153712925.jpeg",
    "description": "Meslek TanıtımıÖĞRENCİ GÖZÜYLE MESLEKLER PROJESİÖzel Güney Gelişim Anadolu Lisesi 10 ve 11. sınıf öğrencilerimiz yarınlara bilinçli ve sağlam adımlar atmak için seçecekleri mesleklerle ilgili bir araştırma projesine imza attılar. Öğrencilerimiz inşaat mühendisliği, mimarlık, mekatronik, otomotiv mühendisliği, bilgisayar mühendisliği, tıp, diş hekimliği, gastronomi, hukuk, lojistik gibi farklı meslekleri yakından tanımak için  bir gün boyunca meslek sahası içerisinde meslek sahipleriyle bir arada bulundu. Yaptıkları gözlem ve röportajları bir sunum haline getirerek konferans salonumuzda arkadaşlarına sundular. Sunumlarını en iyi hazırlayıp aktaran öğrencilerimiz jüri tarafından ödüllendirildi.",
    "gallery": [
      "/files/images/l2552017153712925.jpeg",
      "/files/images/l2552017153812160.jpeg",
      "/files/images/l2552017153812347.jpeg",
      "/files/images/l2552017153812504.jpeg",
      "/files/images/l2552017153812675.jpeg",
      "/files/images/l2552017153812816.jpeg",
      "/files/images/l2552017153812988.jpeg",
      "/files/images/l2552017153912129.jpeg",
      "/files/images/l2552017153912285.jpeg"
    ],
    "video": ""
  },
  {
    "id": "quiz-show",
    "title": "Quiz Show",
    "image": "/files/images/l175201711593810.JPG",
    "description": "Quiz ShowEnglish and German High School Quiz Show was held in our conference hall. There were four great teams, competing in front of a large crowd made up of 5th to 11th graders. We coment our students for their good-humored sportsmanship. We congratulate each one of our teams including the winning team of the challenge who were \"Angel Beats Team\" members.İngilizce ve Almanca Lise Quiz Show, okulumuz konferans salonunda düzenlendi.  5. sınıftan - 11. sınıfa büyük bir seyirci kitlesinin önünde yarışan dört takımımızı oluşturan öğrencileri centilmence yarıştıkları için takdir ediyor, kazanan takım \"Angel Beats\" de dahil bütün yarışmacıları tebrik ediyoruz.",
    "gallery": [
      "/files/images/l175201711593810.JPG",
      "/files/images/l175201711239232.JPG",
      "/files/images/l175201711539120.JPG",
      "/files/images/l175201711739229.JPG",
      "/files/images/l175201711839963.JPG",
      "/files/images/l1752017111139994.JPG",
      "/files/images/l1752017111539416.JPG",
      "/files/images/l1752017111839213.JPG",
      "/files/images/l1752017112039901.JPG",
      "/files/images/l2552017105017809.jpeg",
      "/files/images/l255201710018965.jpeg"
    ],
    "video": ""
  },
  {
    "id": "bilgi-yarismasi",
    "title": "BİLGİ YARIŞMASI",
    "image": "/files/images/l55201712553960.JPG",
    "description": "BİLGİ YARIŞMASIOkulumuzda lise sınıflar arası Bilgi Yarışması yapıldı. Yarışmaya katılan ve dereceye giren öğrencilerimizi tebrik ederiz.",
    "gallery": [
      "/files/images/l55201712553960.JPG",
      "/files/images/l55201712853976.JPG",
      "/files/images/l552017121053944.JPG",
      "/files/images/l552017121353257.JPG",
      "/files/images/l552017121553257.JPG"
    ],
    "video": ""
  },
  {
    "id": "zicev-sosyal-sorumluluk-etkinligi",
    "title": "Ziçev sosyal sorumluluk etkinliği",
    "image": "/files/images/l552017122340646.JPG",
    "description": "Ziçev sosyal sorumluluk etkinliğiZiçev Güney Gelişim Okullarında..",
    "gallery": [
      "/files/images/l552017122340646.JPG",
      "/files/images/l552017122440427.JPG",
      "/files/images/l552017122540224.JPG",
      "/files/images/l552017122540943.JPG",
      "/files/images/l552017122640287.JPG",
      "/files/images/l552017122640724.JPG"
    ],
    "video": ""
  },
  {
    "id": "nesiller-arasi-siir-dinletisi",
    "title": "Nesiller arası şiir dinletisi",
    "image": "/files/images/l284201711192842.JPG",
    "description": "Nesiller arası şiir dinletisiNesilleri, şiir, müzik ve dans paydasında buluşturan dinletimiz duygulu ve keyifli anlar yaşatmasını sağladı.",
    "gallery": [
      "/files/images/l284201711192842.JPG",
      "/files/images/l2842017111928760.JPG",
      "/files/images/l2842017112028276.JPG",
      "/files/images/l2842017112028792.JPG",
      "/files/images/l2842017112128167.JPG",
      "/files/images/l2842017112128792.JPG",
      "/files/images/l2842017112228276.JPG",
      "/files/images/l2842017112328151.JPG",
      "/files/images/l2842017112428182.JPG",
      "/files/images/l2842017112428917.JPG",
      "/files/images/l2842017112628104.JPG",
      "/files/images/l2842017112628807.JPG",
      "/files/images/l2842017112728495.JPG",
      "/files/images/l2842017112828104.JPG"
    ],
    "video": ""
  },
  {
    "id": "pearson-progress-exams",
    "title": "Pearson Progress EXAMS",
    "image": "/files/images/l2132017105427284.jpg",
    "description": "Pearson Progress EXAMSPearson ProgressEXAMSAll of our HIGHSCHOOL students took a day to sit the Pearson Progress Exam.  The online exam, which is overseen directly from the exam headquarters in England, measures students' proficiency in English as well as their progress.  Our aim is to put our graduates onto the road of passing the Y.Ö.K. approved PTE Academic and TOEFL exams with flying colours.Lise öğrencilerimizin İngiltere merkezli online Pearson Progress sınavlarına  girerek  İngilizce seviyeleri ve ilerlemeleri ölçüldü. Ana amacımız Lisemizi başarıyla bitiren öğrencilerimizin Y.Ö.K tarafından onaylanmış  PTE Academic ve TOEFL sınavlarında başarılı olmalarıdır.",
    "gallery": [
      "/files/images/l2132017105427284.jpg",
      "/files/images/l2132017105427378.jpg"
    ],
    "video": ""
  },
  {
    "id": "munazara",
    "title": "MÜNAZARA",
    "image": "/images2/img2_files/logo.jpg",
    "description": "MÜNAZARA“Avrupa Birliğine Girmek Ülkemizi Olumlu Etkiler, Olumsuz Etkiler” konulu münazaramız,  öğrencilerimizin hazırladığı etkili savunmalar sayesinde büyük bir gördü. Tatlı bir rekabet havasında geçen münazaramızda başarıyla görev alan öğrencilerimizi tebrik ediyoruz.",
    "gallery": [],
    "video": ""
  },
  {
    "id": "hazirliksiz-konusma-",
    "title": "HAZIRLIKSIZ KONUŞMA ",
    "image": "/files/images/l143201713748423.JPG",
    "description": "HAZIRLIKSIZ KONUŞMAİletişim becerilerini geliştirmek, duygu ve düşüncelerini etkili ifade etmek, hitap yeteneğini güçlendirmek amacıyla düzenlediğimiz “Hazırlıksız Konuşma Yarışması” öğrenciler tarafından büyük beğeni topladı. Başarılı konuşmalarıyla dinleyenleri etkileyen öğrencilerimizle gurur duyuyoruz.",
    "gallery": [
      "/files/images/l143201713748423.JPG",
      "/files/images/l1432017131048486.JPG",
      "/files/images/l1432017131348126.JPG",
      "/files/images/l1432017131548251.JPG",
      "/files/images/l1432017131848360.JPG",
      "/files/images/l143201713204879.JPG"
    ],
    "video": ""
  },
  {
    "id": "oku-–-bulus-–-paylas-projesi",
    "title": "OKU – BULUŞ – PAYLAŞ PROJESİ",
    "image": "/files/images/l13201714233277.jpg",
    "description": "OKU – BULUŞ – PAYLAŞ PROJESİOKU – BULUŞ – PAYLAŞ PROJESİKitap okumayı bir sanata dönüştürmek okumanın ve paylaşmanın değerini yaşatmak isteğiyle yola çıktık.Okuduğumuz kitapları içselleştirmek için buluştuğumuz Sosyal Bilimler Lisesi öğrencileriyle yaptığımız beyin fırtınası ve entelektüel sohbet sonrasında kitaplardan kesitler drama ettik.Öğrencilerimiz için kitap okumak artık daha anlamlı.",
    "gallery": [
      "/files/images/l13201714233277.jpg",
      "/files/images/l13201714233546.jpg",
      "/files/images/l13201714233792.jpg",
      "/files/images/l1320171433311.jpg",
      "/files/images/l13201714333292.jpg",
      "/files/images/l13201714333433.jpg",
      "/files/images/l13201714333574.jpg",
      "/files/images/l13201714333714.jpg",
      "/files/images/l13201714333824.jpg",
      "/files/images/l13201714333933.jpg",
      "/files/images/l1320171443342.jpg",
      "/files/images/l13201714433152.jpg",
      "/files/images/l13201714433245.jpg",
      "/files/images/l13201714433402.jpg"
    ],
    "video": "https://www.youtube.com/embed/7C82XWe6Oeg?ecver=1"
  },
  {
    "id": "guney-gelisim-okullari-erciyes-gezisinden-kareler-",
    "title": "GÜNEY GELİŞİM OKULLARI ERCİYES GEZİSİNDEN KARELER ",
    "image": "/files/images/l222201791751183.JPG",
    "description": "GÜNEY GELİŞİM OKULLARI ERCİYES GEZİSİNDEN KARELER",
    "gallery": [
      "/files/images/l222201791751183.JPG",
      "/files/images/l222201791751964.JPG",
      "/files/images/l222201791851729.JPG",
      "/files/images/l222201791951573.JPG",
      "/files/images/l222201792051308.JPG",
      "/files/images/l22220179215189.JPG",
      "/files/images/l222201792151698.JPG",
      "/files/images/l222201792351604.JPG",
      "/files/images/l222201792351683.JPG",
      "/files/images/l222201792351823.JPG",
      "/files/images/l222201792351917.JPG",
      "/files/images/l22220179245142.JPG",
      "/files/images/l222201792451183.JPG"
    ],
    "video": "https://www.youtube.com/embed/P57lGmp_L0w?ecver=1"
  },
  {
    "id": "cern-gezisi",
    "title": "Cern Gezisi",
    "image": "/files/images/l92201714615531.JPG",
    "description": "Cern Gezisi16 - 21 Aralık 2016 tarihleri arasında  Özel Güney Gelişim Koleji Lise öğrencileri Cern Avrupa Nükleer Araştırma Merkezi başta olmak üzere Parisi ziyaret ettiler.",
    "gallery": [
      "/files/images/l92201714615531.JPG",
      "/files/images/l92201714815500.JPG",
      "/files/images/l922017141015281.JPG",
      "/files/images/l92201714111547.JPG"
    ],
    "video": ""
  }
];